import { Theme } from '@mui/material';

export const containerTableStyle = (containerMaxHeight: number) => ({
  '> div': {
    maxHeight: `${containerMaxHeight ? containerMaxHeight : 300}px`,
    overflowY: 'auto',
  },
});

export const editTableStyle = (theme: Theme) => tableStyle(theme, true);
export const tableStyle = (theme: Theme, isEditing?: boolean) => ({
  '.rdt_TableBody': {
    '.rdt_TableCell': {
      padding: isEditing ? '8px' : '0 8px',
      '> .MuiFormControl-root': {
        margin: '16px 0 -4px',
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'flex-start',
        height: '100%',
      },
    },
    '> div': {
      '.rdt_TableCell': {
        '> button': {
          display: 'block',
        },
      },
    },
  },
});
